var fullMenuWidth = "240px";
var collapsedMenuWidth = "54px";
var globalNav = {
    base: {
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        width: fullMenuWidth,
        height: "100%",
        font: "body",
        alignContent: "start",
        transition: "width ease-out, left ease-out",
        transitionDuration: 6,
        bg: "brandDark.100",
        "[data-nav-item]": {
            transition: "padding ease-out, columnGap ease-out",
            transitionDuration: 4,
            "[data-label]": {
                transition: "opacity ease-out",
                transitionDuration: 6,
            },
        },
        "[data-nav-toggle]": {
            transition: "transform ease-out",
            transitionDuration: 6,
        },
        "[data-decor]": {
            opacity: 1,
            transition: "opacity ease-out",
            transitionDuration: 6,
            transitionDelay: 3,
        },
        "[data-notify-dot-collapsed=true]": {
            opacity: 0,
            transition: "opacity ease-out",
            transitionDuration: 3,
            transitionDelay: 2,
        },
        "&[data-is-collapsed=true]": {
            width: collapsedMenuWidth,
            transition: "width ease-in",
            transitionDuration: 6,
            "[data-main-nav-header]": {
                px: "8px",
            },
            "[data-nav-item]": {
                px: "10px",
                columnGap: 0,
                transition: "column-gap ease-in, padding ease-in",
                transitionDuration: 6,
                "[data-label]": {
                    transition: "opacity ease-in",
                    transitionDuration: 6,
                    opacity: 0,
                },
            },
            "[data-nav-toggle]": {
                transform: "rotate(180deg)",
            },
            "[data-icon]": { mr: 0 },
            "[data-decor]": {
                opacity: 0,
                transition: "opacity ease-in",
                transitionDuration: 3,
            },
            "[data-notify-dot-collapsed=true]": {
                opacity: 1,
                transition: "opacity ease-in",
                transitionDuration: 3,
            },
        },
    },
};
var globalNavSection = {
    base: {
        boxSizing: "border-box",
        px: 7,
        py: 5,
        borderBottom: "1px solid",
        borderBottomColor: "brandDark.80",
        fontSize: 2,
    },
};
var globalNavHeader = {
    base: {
        boxSizing: "border-box",
        display: ["none", "flex"],
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "62px",
        px: "16px",
        transition: "padding ease-out",
        transitionDuration: 6,
        "[data-ui-logo-mark]": {
            fontSize: "iconMd",
        },
    },
};
var globalNavSkipLink = {
    base: {
        fontSize: "md",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
};
var globalNavItems = {
    base: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridRowGap: 3,
        bg: "brandDark.100",
        px: 3,
        pt: "2px",
    },
};
var globalNavNotifyDot = {
    base: {
        color: "critical.60",
        position: "relative",
        right: "calc(1em / 3)",
        "&[data-notify-dot-collapsed=true]": {
            opacity: 0,
        },
    },
};
var globalNavItem = {
    base: {
        font: "body",
        alignItems: "center",
        justifyItems: "start",
        minWidth: 0,
        display: "grid",
        gridTemplateColumns: "1fr",
        gridAutoColumns: "min-content",
        columnGap: "0.5rem",
        textDecoration: "none",
        whiteSpace: "nowrap",
        fontSize: "sm",
        borderWidth: 0,
        borderRadius: 3,
        height: "38px",
        px: 5,
        bg: "brandDark.100",
        color: "brandDark.40",
        "&[data-current], &[aria-current]": {
            bg: "brandDark.80",
            color: "white",
        },
        ":hover:not([data-disabled=true])": {
            bg: "brandDark.90",
            cursor: "pointer",
            textDecoration: "none",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px" },
    },
};
var globalNavMenu = {
    base: {
        font: "body",
        alignItems: "center",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridAutoColumns: "min-content",
        columnGap: "0.5rem",
        justifyItems: "start",
        minWidth: 0,
        whiteSpace: "nowrap",
        textDecoration: "none",
        fontSize: "sm",
        borderWidth: 0,
        borderRadius: 3,
        height: "38px",
        px: 5,
        bg: "brandDark.100",
        color: "brandDark.40",
        "&[data-current], &[data-is-open=true]": {
            bg: "brandDark.80",
        },
        "&[data-current][data-is-open=true]": {
            color: "brandDark.40",
        },
        "&[data-current][data-is-open=false]": {
            color: "white",
        },
        ":hover:not([data-disabled=true])": {
            bg: "brandDark.90",
            cursor: "pointer",
            textDecoration: "none",
        },
        "&[data-disabled=true]": {
            color: "brandDark.60",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px" },
    },
};
var globalNavMenuItems = {
    base: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: 3,
        borderRadius: 3,
        bg: "brandDark.90",
        py: 3,
        mt: 1,
    },
};
var globalNavMenuItem = {
    base: {
        font: "sm",
        alignItems: "center",
        display: "flex",
        minWidth: 0,
        whiteSpace: "nowrap",
        textDecoration: "none",
        borderWidth: 0,
        borderRadius: 0,
        height: "38px",
        px: "16px",
        pl: "42px",
        bg: "brandDark.90",
        color: "brandDark.40",
        "&[data-current], &[aria-current]": {
            bg: "brandDark.80",
            color: "white",
        },
        ":hover:not([data-disabled=true])": {
            bg: "brandDark.80",
            cursor: "pointer",
            textDecoration: "none",
        },
        "[data-icon]": { lineHeight: 0, fontSize: "18px" },
    },
};
var globalNavToggle = {
    base: {
        display: ["none", "block"],
        color: "brandDark.40",
        justifySelf: "end",
        ":hover": { color: "white" },
    },
};

export { globalNav, globalNavHeader, globalNavItem, globalNavItems, globalNavMenu, globalNavMenuItem, globalNavMenuItems, globalNavNotifyDot, globalNavSection, globalNavSkipLink, globalNavToggle };
//# sourceMappingURL=global-nav.js.map
